import { render, staticRenderFns } from "./ProjectReprintAndCancellation.vue?vue&type=template&id=b241f4d4&scoped=true&lang=pug&"
import script from "./ProjectReprintAndCancellation.vue?vue&type=script&lang=ts&"
export * from "./ProjectReprintAndCancellation.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectReprintAndCancellation.vue?vue&type=style&index=0&id=b241f4d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b241f4d4",
  null
  
)

export default component.exports